module.exports = __webpack_public_path__ + "img/freight_yard3_1.4f1df892.png";